module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider",
    on: {
      "mouseleave": _vm.play,
      "mouseenter": _vm.pause
    }
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide",
      on: {
        "click": function($event) {
          return _vm.$router.push(("/portfolio?page=1&cat=" + (item.categories) + "&id=" + (item.id)))
        }
      }
    }, [_c('img', {
      staticClass: "img",
      attrs: {
        "src": item.image
      }
    }), _c('div', {
      staticClass: "logo"
    }, [_c('img', {
      attrs: {
        "src": item.logo
      }
    }), _c('div', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(_vm.lang === 'zh' ? item.slogan : item.slogan_en))])])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-232fdbac","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider.vue
// module id = 506
// module chunks = 1